import { gql } from '@apollo/client';
import vehiclePreviewFragment from '../../fragments/vehiclePreviewApollo';

export default gql`
  query GET_LIVE_VEHICLES($sort: String, $limit: Int, $start: Int, $where: JSON) {
    vehicles(sort: $sort, limit: $limit, start: $start, where: $where) {
      ...VehiclePreview
    }
    vehiclesConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
  ${vehiclePreviewFragment}
`;
